let _isMobile = null;

let _isMobileOrTablet = null;

export function isMobile() {
    if (_isMobile === null) {
        _isMobile = !!window.matchMedia && window.matchMedia('(max-width: 46.875em)').matches; // We are mobile because the media query rule match
    }
    return _isMobile;
}

export function isMobileOrTablet() {
    if (_isMobileOrTablet === null) {
        _isMobileOrTablet =
            !!window.matchMedia && window.matchMedia('(max-width: 63.9375em)').matches; // We are mobile or tablet because the media query rule match
    }
    return _isMobileOrTablet;
}

export function isSafariOnIos() {
    return window.navigator.userAgent.match(
        /.*(iPod|iPhone|iPod).*AppleWebKit\/[^/]*Version\/[^/]*Mobile\/[^/]*Safari\//,
    );
}

export function hasTouchEvents() {
    // From Modernizr 3 touchevent test, not 100% reliable but OK for our user population
    return 'ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch);
}
